<div class="table-container">
    <table class="table">
        <tbody>
            <tr class="tr" [class.form-inactive]="!showCreateForm">
            <td colspan="2">
                <comments-details
                    [currentTicket]="currentTicket"
                    [editModeComment]="true">
                </comments-details>
            </td>
        </tr>
        <ng-container *ngFor="let comment of comments | async">
            <tr *ngIf="selectedComment !== comment" [class.selected]="comment === selectedComment">
                <td class="container" colspan="2">
                    <div class="comment-user">
                        {{ comment.userId ? (user.makeLabel(comment.userId) | async) : '' }}
                    </div>
                    <div class="comment-item">
                        <div class="comment-content" [innerHTML]="sanitizeContent(comment.content)"></div>
                        <button class="btn-edit" (click)="editComment(comment, $event)">
                            <span class="material-icons-outlined">edit</span>
                        </button>
                    </div>
                </td>
            </tr>
            <tr *ngIf="selectedComment === comment" class="details-row">
                <td colspan="2">
                    <div class="details-container">
                        <comments-details class="comments-details"
                                          [currentTicket]="currentTicket"
                                          [selectedComment]="selectedComment"
                                          [editModeComment]="true">
                        </comments-details>
                        <div class="edit-header">
                            <button class="btn-cancel" (click)="cancelEdit($event)">
                                <span class="material-icons-outlined">close</span> 
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>
</div>